
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 37","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#111","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M33.818 4.455H39v30.587H1V4.455h5.182M20 4.455v13.818"}}),_c('path',{attrs:{"d":"M20 4.455C18.236 2.764 14.746 1 6.182 1v25.475c8.6 0 12.09 1.727 13.818 3.454 1.727-1.69 5.146-3.454 13.818-3.454V1C25.182 1 21.728 2.727 20 4.455z"}})])])
          )
        }
      }
    